import { render, staticRenderFns } from "./ComplianceElementsFailingIn30Days.vue?vue&type=template&id=53cffdaa&"
import script from "./ComplianceElementsFailingIn30Days.vue?vue&type=script&lang=ts&"
export * from "./ComplianceElementsFailingIn30Days.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports